import {toast, ToastContainer} from "react-toastify";
import React from "react";

const errorMessage = (message: string, toastId: number) => {
    toast.error(message, {
        toastId: toastId,
        draggablePercent: 60,
        position: toast.POSITION.TOP_RIGHT,
        pauseOnFocusLoss: false,
        // autoClose: 15000,
    })
};

const successMessage = (message: string, toastId: number) => {
    toast.success(message, {
        toastId: toastId,
        draggablePercent: 60,
        position: toast.POSITION.TOP_RIGHT,
        pauseOnFocusLoss: false,
        // autoClose: 15000,
    })
};

export const showMessageError = (message: string, toastId: number) => {
    errorMessage(message, toastId);
}

export const showMessageSuccess = (message: string, toastId: number) => {
    successMessage(message, toastId);
}

export const showError = (items: { [x: string]: string; }[]) => {
    items.map((value: { [x: string]: string; }, index: number) => {
            Object.keys(value).map((key) => (
                errorMessage(value[key], index)
            ))

            return false;
        }
    )
}

export const hideAllError = () => {
    toast.dismiss();
}

export const containerError = () => {
    return <ToastContainer/>;
}